export default __webpack_public_path__ + "static/media/plus.c20cc1da.svg";